import styled from "styled-components";
import { LEVEL_COLORS } from "components/shared/TagLevelSmall/TagLevelSmall";
import { pillTone, SOLO_ACCURACY_RULE } from "utils/soloAccuracy";

// A student's solo score as the fraction the backend counted: right out of
// asked, coloured by accuracy.
//
// The colours are the level badges' own, since this pill replaces them on the
// collapsed report row and the teacher has already learned to read them.
//
// An em dash means the student had nothing to score. It is never shown for a
// score we merely failed to fetch — that case keeps the level badge, because
// "nothing to score" is a claim about the child and a network error is not.

export const SCORE_PILL_COLORS = {
  red: LEVEL_COLORS[1],
  yellow: LEVEL_COLORS[2],
  green: LEVEL_COLORS[3],
};

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 11px;
  padding: 2px 8px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  line-height: 1.4;
  max-height: 24px;
  background-color: ${({ $bg }) => $bg};
  border: 1px solid ${({ $border }) => $border};
  color: ${({ $text }) => $text};
`;

const NoScore = styled.span`
  white-space: nowrap;
`;

/**
 * @param {number} correct
 * @param {number} answered
 * @param {number|null} accuracy 0-100.
 * @param {boolean} [notApplicable]
 */
export const ScorePill = ({ correct, answered, accuracy, notApplicable }) => {
  const colorSet = SCORE_PILL_COLORS[pillTone(accuracy)];
  if (notApplicable || !answered || !colorSet) return <NoScore aria-label="No score">—</NoScore>;

  return (
    <Pill
      $bg={colorSet.bg}
      $border={colorSet.border}
      $text={colorSet.text}
      title={SOLO_ACCURACY_RULE}
    >
      {`${correct}/${answered}`}
    </Pill>
  );
};
